import React, {ReactElement, useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import * as Yup from 'yup';
import {useHistory} from 'react-router-dom';
import AppHeader from '../../../components/appbar/AppBar';
import {
  getTempPassword,
  setStoreCode,
  setStoreEmployeeInfo,
  setStoreInformation,
  setUserType,
} from '../../../core/localstorage-data';

import useGeoLocation from '../../../components/common/useGeoLocation';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {LOCATION, RESET_PASSWORD} from '../../../routes/route-constants';
import {STORE_LOCATION} from '../../../routes/route-constants';

import {TEMP_PASSWORD} from '../../../routes/route-constants';
import {
  fetchStoreInformation,
  storeInformation,
  error,
  resetStoreInformation,
} from '../../../redux/storeInformationSlice';
import {setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';
import {
  signInEmployee,
  employeeAllData,
  errorData,
  loading,
  resetState,
} from '../../../redux/employeeSignInSlice';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../../components/notifications/ErrorToast';
import {distancePoints} from '../../../lib/commonFunction';
import {setEmployeeId} from '../../../redux/employeeIdSlice';

const employeeSignIn = (): ReactElement => {
  const dispatch = useAppDispatch();
  const location = useGeoLocation();
  const employeeData = useAppSelector(employeeAllData);
  const employeeDataHasLoaded = useAppSelector(loading);
  const errorInEmployeeData = useAppSelector(errorData);
  const errorInStoreInfoApi = useAppSelector(error);

  const storeInformationData = useAppSelector(storeInformation);
  const navigate = useHistory();
  useEffect(() => {
    const userTypeData = 'employee';
    setUserType(userTypeData);
    setPageName(pageName.employeesigninPage);
    if (storeInformationData.entity != '') {
      dispatch(resetStoreInformation());
    }
  }, []);

  //employee sign in api useeffect
  useEffect(() => {
    if (employeeData.statusMessage != '' && employeeDataHasLoaded === false) {
      if (employeeData.statusCode == '200') {
        if (employeeData.data.status === 'A') {
          setStoreCode(employeeData.data.stroreId);
          setStoreEmployeeInfo(employeeData);
          const payload = {
            store_code: employeeData.data.stroreId,
            mobile_number: '',
          };
          dispatch(fetchStoreInformation(payload));
        } else {
          cogoToast.error(
            <ErrorToast
              title="Error"
              description="You are not the active employee"
            />,
            {
              hideAfter: 4,
              renderIcon: () => {
                return null;
              },
            },
          );

          dispatch(resetState());
          return;
        }
      } else {
        cogoToast.error(
          <ErrorToast title="Error" description={employeeData.statusMessage} />,
          {
            hideAfter: 4,
            renderIcon: () => {
              return null;
            },
          },
        );

        dispatch(resetState());
        return;
      }
    }
    if (errorInEmployeeData != '' && employeeDataHasLoaded === false) {
      cogoToast.error(
        <ErrorToast title="Error" description="Internal Server Error" />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [employeeData, employeeDataHasLoaded, errorInEmployeeData]);

  //store info api useEffect
  useEffect(() => {
    if (Object.keys(storeInformationData).length === 0) {
      //  dispatch(setEnableMobileInput(true));
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Currently we are not able to fetch store information. Please try again."
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
    if (storeInformationData != null && storeInformationData.result === true) {
      // setStoreName(storeInformationData.store_name);
      //  setStoreInformation(storeInformationData);
      if (employeeData.data.pwdChgReq === 'Y') {
        dispatch(setEmployeeId(employeeData.data.userId));
        navigate.push(RESET_PASSWORD);
      }
      if (employeeData.data.pwdChgReq === 'N') {
        const storeLat = 28.7254557;
        const storeLong = 77.2060128;
        const userLat = 28.7234;
        const userLong = 77.206;
        // const storeLat = storeInformationData.latitude;
        // const storeLong = storeInformationData.longitude;
        // const userLat = location.coordinates.lat;
        // const userLong = location.coordinates.lng;
        const distance = distancePoints(
          userLat,
          userLong,
          storeLat,
          storeLong,
          //getStoreLatitude(),
          //getStoreLongitude(),
        );
        // const distance1 = 301;
        if (distance <= 300) {
          navigate.push(STORE_LOCATION);
        } else {
          navigate.push(LOCATION);
        }
      }
    }
    if (errorInStoreInfoApi != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Currently we are not able to fetch store information. Please try again."
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [storeInformationData, errorInStoreInfoApi]);

  const initialValues = {
    employeeid: '',
    password: '',
  };

  const validationSchema = Yup.object({
    employeeid: Yup.string()
      .max(40, 'Max length execeeding')
      .required('*Please enter employee id'),
    password: Yup.string()
      .max(40, 'Max length execeeding')
      .required('*Please enter password'),
  });
  const forgetPasswordhandler = () => {
    if (location.error.message != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Please allow location to continue"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      return;
    }
    navigate.push(TEMP_PASSWORD);
  };
  const onSubmit = (
    values: any,
    submitProps: {
      setSubmitting: (arg0: boolean) => void;
      resetForm: () => void;
    },
  ) => {
    submitProps.setSubmitting(false);
    if (location.error.message != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Please allow location to continue"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      submitProps.resetForm();
      return;
    }
    const parameter = {
      userId: values.employeeid,
      password: values.password,
    };

    dispatch(signInEmployee(parameter));
    submitProps.resetForm();
  };

  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="py-4 px-8 top-spacing-ipad">
        <div className="grid place-items-center overflow-y-auto">
          <span className="font-roboto text-big text-center font-bold">
            Sign in{' '}
          </span>
        </div>
        <div className="mt-2">
          <p className="text-sm mt-2 text-black_zero text-center text-opacity-50 font-roboto">
            Enter email ID and password to get started with Max Buddy
          </p>
        </div>
        <div className="mt-1">
          <Formik
            className="flex justify-items-stretch mx-auto max-w-screen-md relative flex-grow mt-6"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize>
            {formik => {
              return (
                <Form>
                  <div>
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.employeeid && formik.touched.employeeid
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Employee ID
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="text"
                        name="employeeid"
                        placeholder="Enter X digit employee ID"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.employeeid && formik.touched.employeeid ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.employeeid}
                      </div>
                    ) : null}
                  </div>
                  <div className="mt-6">
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.password && formik.touched.password
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Password
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="password"
                        name="password"
                        placeholder="Enter password"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.password && formik.touched.password ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                  <div className="text-sm mt-2 text-black_zero text-opacity-50 font-roboto text-right">
                    <a onClick={forgetPasswordhandler}>
                      <span className="text-red_zero font-bold font-roboto ">
                        Forgot password
                      </span>
                    </a>
                  </div>
                  <div style={{marginTop: '24px'}}>
                    <button
                      className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}
                      type="submit"
                      disabled={!(formik.dirty && formik.isValid)}>
                      <p className="font-bold font-roboto">Sign in</p>
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default employeeSignIn;
